import React from "react";
import Layout from "./componentes/Layout";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Unidades, TipoDeActivos, TipoDeVulnerabilidades, TipoDeAmenazas, DimDeVal, DimensionValoracion, Probabilidades } from "./pages/Parametrizacion";
import { Activos, Vulnerabilidades, Amenazas, Contramedidas } from "./pages/Medicion";
import { Activos as Act, ValDeImpac } from "./pages/Activos";
import { AmenazasPVul } from "./pages/Vulnerabilidades";
import { Gestionar } from "./pages/Gestionar";
import { Edit } from "./pages/Edit";
import { Riesgo } from "./pages/Riesgo";
import { Graficos } from "./pages/Graficos";
import RegisterPage from "./pages/RegisterPage";
import LoginPage from "./pages/LoginPage";
import { AuthProvider } from "./context/AuthContext";
import ProfilePage from "./pages/ProfilePage";
import { ProtectedRoute } from "./ProtectedRoute";
import { VulnerabilidadAmenaza } from "./pages/VulnerabilidadAmenaza";
import Inicio from "./pages/Inicio";
import { Empresas } from "./pages/Empresas";
import { GestionCuentas } from "./pages/GestionCuentas";
import { GestionEmpleados } from "./pages/GestionEmpleados";
import { RoleProtectedRoute } from "./RoleProtectedRoute";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />

          {/* Protected Routes wrapped in Layout */}
          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              <Route path="/profile" element={<ProfilePage />} />

              <Route path="/inicio/general" element={<Inicio />} />

              <Route path="/parametrizacion/unidades" element={<Unidades />} />
              <Route path="/parametrizacion/tipo-de-activos" element={<TipoDeActivos />} />
              <Route path="/parametrizacion/tipo-de-vulnerabilidades" element={<TipoDeVulnerabilidades />} />
              <Route path="/parametrizacion/tipo-de-amenazas" element={<TipoDeAmenazas />} />
              <Route path="/parametrizacion/dimensiones-de-valoracion" element={<DimensionValoracion />} />
              <Route path="/parametrizacion/probabilidades" element={<Probabilidades />} />
              <Route path="/parametrizacion/amenazas" element={<Amenazas />} />
              <Route path="/parametrizacion/vulnerabilidades" element={<Vulnerabilidades />} />
              <Route path="/parametrizacion/contra-medidas" element={<Contramedidas />} />

              <Route path="/medicion/activos" element={<Activos />} />
              <Route path="/medicion/valor-de-impacto" element={<ValDeImpac />} />
              <Route path="/medicion/amenazas-por-vulnerabilidad" element={<AmenazasPVul />} />

              <Route path="/gestionar/nuevo-proceso" element={<Gestionar />} />
              <Route path="/gestionar/vulnerabilidad-amenaza" element={<VulnerabilidadAmenaza />} />
              <Route path="/gestionar/editar-vulnerabilidades" element={<Edit />} />
              <Route path="/gestionar/Calculo-Riesgo" element={<Riesgo />} />
              <Route path="/graficos/heatmap" element={<Graficos />} />

              <Route element={<RoleProtectedRoute allowedRoles={["Admin"]} />}>
                <Route path="/empleados/gestion" element={<GestionEmpleados />} />
              </Route>

              <Route element={<RoleProtectedRoute allowedRoles={["SuperAdmin"]} />}>
                <Route path="/empresas/gestion" element={<Empresas />} />
                <Route path="/cuentas/gestion" element={<GestionCuentas />} />
              </Route>
            </Route>
          </Route>
        </Routes>
      </Router>
      <ToastContainer position="bottom-left" autoClose={3000} />
    </AuthProvider>
  );
}

export default App;
